function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 391
// module chunks = 231608221292675